import React from 'react';

export class AltCheckbox extends React.Component {
  static defaultProps = {
    title: 'Clique para alterar o status',
    className: 'split2',
    message: null
  };

  render() {
    const { className, title, checked, value, name, id, label, message, onChange, style, disabled } = this.props;

    return (
      <label
        className={`alt-checkbox ${className || ''}`}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 8, verticalAlign: 'middle', ...style }}
        title={title}
      >
        <span className={`togglecheck ${checked ? 'selected' : ''}`} />
        <input
          checked={checked}
          value={value}
          name={name}
          type="checkbox"
          id={id}
          onChange={onChange}
          disabled={disabled}
          style={{ display: 'none' }}
        />
        {label ? <span className="alt-checkbox-label">{label}</span> : null}
        {message ? <p className="alt-checkbox-message">{message}</p> : null}
      </label>
    );
  }
}

export default AltCheckbox;
